import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "./Promotion.scss";

import noImageEmart from "../../assets/noImage_emart.jpg";
import noImageNobrand from "../../assets/noImage_nobrand.jpg";
import noImageTraders from "../../assets/noImage_traders.jpg";
import noImageEveryday from "../../assets/noimage_everyday.png";
import noImageLanders from "../../assets/noImage_landers.png";
import storeBanner1 from "../../assets/store_banner1.jpg";

import { useSelector } from "react-redux";
import useReactGASend from "../../hooks/useReactGASend";

const StoreNews = () => {
  return (
    <p className="mt-6 rounded-[20px] overflow-hidden">
      <img src={storeBanner1} alt="점포뉴스배너1" />
    </p>
  );
};

const NoPromoImage = ({ onClick }) => {
  const brandId = useSelector((state) => state.checkArsStatus.brandId);
  return (
    <p className="mt-6 rounded-[20px] overflow-hidden" onClick={onClick}>
      {brandId === "EM" ? (
        <img
          src={noImageEmart}
          alt="믿고 사는 즐거움 이마트"
          className="w-full"
        />
      ) : brandId === "NB" ? (
        <img
          src={noImageNobrand}
          alt="노브랜드 브랜드가 아니다. 소비자다."
          className="w-full"
        />
      ) : brandId === "ED" ? (
        <img
          src={noImageEveryday}
          alt="EverydayFresh. 이마트 에브리데이"
          className="w-full"
        />
      ) : brandId === "LD" ? (
        <img
          src={noImageLanders}
          alt="SSG 랜더스"
          className="w-full"
        />
      ) : (
        <img
          src={noImageTraders}
          alt="열린 창고형 매장에 가치를 더하다."
          className="w-full"
        />
      )}
    </p>
  );
};
const PromotionSwiper = ({ promoItems }) => {
  const { makeEventTrackFn } = useReactGASend();

  const trackLinkClick = (title) => {
    makeEventTrackFn({
      category: "event",
      action: `배너이미지 ${title}`,
    });
  };
  return (
    <Swiper
      pagination={{ type: "fraction" }}
      modules={[Pagination]}
      className="main_banner"
      loop={true}
    >
      {promoItems.map((item, index) => (
        <SwiperSlide key={index}>
          <PromotionItem {...item} onClick={() => trackLinkClick(item.title)} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

const PromotionItem = ({ img, label, link }) => {
  const imageElement = <img src={img} alt={label} className="w-full" />;

  return link ? (
    <a href={link} className="block w-full h-full">
      {imageElement}
    </a>
  ) : (
    imageElement
  );
};

const Promotion = ({ promoItems, isStoreNews }) => {
  return (
    <>
      {isStoreNews ? (
        <StoreNews />
      ) : (
        <>
          {promoItems?.length ? (
            <PromotionSwiper promoItems={promoItems} />
          ) : (
            <NoPromoImage />
          )}
        </>
      )}
    </>
  );
};
export default Promotion;
